export default "__VITE_ASSET__CpepBgku__"